// utilities
const screenisCompact = 1200 >= window.innerWidth ? true : false;
const screenIsTablet = 900 >= window.innerWidth ? true : false;
const screenIsMobile = 600 >= window.innerWidth ? true : false;
let lastFocusedElement = null;

const getOffset = el => {
	let elBounding = el.getBoundingClientRect();

	return {
		top: elBounding.top + window.scrollY,
		left: elBounding.left + window.scrollX,
	};
};

const formatLeadingZero = val => {
	return (val < 10 ? '0' : '') + val;
};

const formatHandleize = str => {
	return str
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/-$/, '')
		.replace(/^-/, '');
};

const slide = (action, el, duration = 400) => {
	const slideDown = () => {
		let childrenHeight = Object.values(el.children).reduce(
			(total, i) => total + i.offsetHeight,
			0
		);

		// Apply active state
		el.classList.add('active');
		el.style.height = 'auto';

		// Set the height of the content as 0px
		// so we can trigger the slide down animation.
		el.style.height = '0px';

		// Do this after the 0px has applied.
		// It's like a delay or something. MAGIC!
		setTimeout(() => {
			el.style.height = `${childrenHeight}px`;
			el.style.transition = `height ${duration}ms`;
		}, 0);
	};

	const slideUp = () => {
		let childrenHeight = Object.values(el.children).reduce(
			(total, i) => total + i.offsetHeight,
			0
		);

		// Set the height as 0px to trigger the slide up animation.
		el.classList.remove('active');
		el.style.height = '0px';
		el.style.transition = `height ${duration}ms`;

		// Remove the active state when the animation ends
		el.addEventListener(
			'transitionend',
			() => {
				el.style.transition = `0s`;
			},
			{ once: true }
		);
	};

	switch (action) {
		case 'down':
			slideDown();
			break;

		case 'up':
			slideUp();
			break;

		case 'toggle':
			!el.classList.contains('active') ? slideDown() : slideUp();
			break;
	}
};

const openAccordionOnLoad = (el, content, button )=>{
	//this is a function to open an accordion as desktop or mobile breakpoints if data-js-accordion-open is present on the accordion element.  Accepts a value of 'mobile' or 'desktop'
	const setActiveAttributes = ()=>{
	//reusable function to slide down and set attributes for the accordion
		if (!el.classList.contains('is-active')) {
			slide('down', content);
			el.classList.add('is-active');
			content.setAttribute('aria-hidden', false);
			content.setAttribute('tabindex', '0');			
		}
		if (!button.classList.contains('is-active')) {
			button.classList.add('is-active');
			button.setAttribute('aria-expanded', true);
		}

	}

	const ratingSummaryListener = (summaryBtn) => {
		summaryBtn.addEventListener('click', e => {
			setActiveAttributes();
		});
	}

	const bvRatingsSummaryObserver = ()=> {
	//reusable mutationObserver function for Bazaarvoice reviews third-party accordion content
		const bvRatingsSummary = document.querySelector('.hero-content .content-review-stars');
		const observerConfig = { childList:true, subtree:true};
		bvReviewsObserver = new MutationObserver(function(mutations_list){
			mutations_list.forEach(function(mutation){
				mutation.addedNodes.forEach(function (addedNode) {
					if (addedNode?.classList?.contains('bv_main_container_row_flex')) {
						summaryBtn = document.querySelector('.product-hero .content-review-stars button.bv_main_container_row_flex');
						ratingSummaryListener(summaryBtn);
						bvReviewsObserver.disconnect();
					}
				});
			});
		});

		bvReviewsObserver.observe(bvRatingsSummary, observerConfig);
	}

	const bvObserver = ()=> {
	//reusable mutationObserver function for Bazaarvoice reviews third-party accordion content
		const bvReviews = el.querySelector('.accordion-content .accordion-content-interior');
		const observerConfig = { childList:true, subtree:true};
		bvReviewsObserver = new MutationObserver(function(mutations_list){
			mutations_list.forEach(function(mutation){
				mutation.addedNodes.forEach(function (addedNode) {
					if (addedNode?.classList?.contains('bv-cleanslate')) {	
						setActiveAttributes();
						bvReviewsObserver.disconnect();
					}
				});
			});
		});

		bvReviewsObserver.observe(bvReviews, observerConfig);
	}

	const bvReviewsPaginationObserver = ()=>{
		//observer to resize the customer reviews accordion when the review content changes height through page or sort changes
		const bvReviewsPage = document.querySelector('.product-reviews .accordion-content .accordion-content-interior');
		const observerConfig = { childList:true, subtree:true};
		bvReviewsPageObserver = new MutationObserver(function(mutations_list){
			mutations_list.forEach(function(mutation){
			mutation.addedNodes.forEach(function (addedNode) {
				if (addedNode?.classList?.contains('bv-content-list-reviews')) {	
				let newHeight = bvReviewsPage.offsetHeight;
				let contentContainer = document.querySelector('.product-reviews .accordion-content');
				contentContainer.style.height = `${newHeight}px`;
				}
			});
			});
		});

		bvReviewsPageObserver.observe(bvReviewsPage, observerConfig);
	}

	if (el.dataset.jsAccordionOpen == 'desktop' && !screenIsTablet ){
		//condition to add a mutation observer to wait for async load if accordion content comes from third pary apps
		if ('jsAccordionAsync' in el.dataset) {
			switch (el.dataset.jsAccordionAsync) {
				//case is for bazaar voice review as part of NYMH-376.  Additional cases can be added as needed.
				case 'bv-reviews':
					bvObserver();
					break;			
				default:
					setActiveAttributes()
					break;
			}
		} 
		else {
			setActiveAttributes();
		}
	}

	if (el.dataset.jsAccordionOpen == 'mobile' && screenIsTablet ){
		if ('jsAccordionAsync' in el.dataset) {
			switch (el.dataset.jsAccordionAsync) {
				case 'bv-reviews':
					bvObserver();
					break;

				default:
					break;
			}
		} 
		else {
			setActiveAttributes();
		}
	}

	if (el.dataset.jsAccordionAsync == 'bv-reviews') {
		bvReviewsPaginationObserver();
		summaryBtn = document.querySelector('.product-hero .content-review-stars button.bv_main_container_row_flex');
		if (summaryBtn) {
			ratingSummaryListener(summaryBtn)
		}
		else {
			bvRatingsSummaryObserver();
		}
		
	}
}

const debounce = (func, wait, immediate)=> {
	let timeout;
	return function() {
		let context = this, args = arguments;
		let later = function() {
		timeout = null;
		if (!immediate) func.apply(context, args);
		};
		let callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


// pieces and components

const initItemQuantity = () => {
	document.addEventListener('click', e => {
		if (
			e.target &&
			(e.target.dataset.quantityTrigger ||
				e.target.closest('[data-quantity-trigger]'))
		) {
			let target = e.target.dataset.quantityTrigger
				? e.target
				: e.target.closest('[data-quantity-trigger]');
			let itemQuantity = target.closest('.item-quantity');
			let quantityInput = itemQuantity.querySelector('input[name="quantity"]');
			let updatedValue =
				parseInt(quantityInput.value) +
				(target.dataset.quantityTrigger == 'increase'
					? parseInt(quantityInput.value) + 1 <= parseInt(quantityInput.max)
						? 1
						: 0
					: parseInt(quantityInput.value) - 1 >= parseInt(quantityInput.min)
					? -1
					: 0);

			quantityInput.value = target.classList.contains('has-leading-zero')
				? formatLeadingZero(updatedValue)
				: updatedValue;
		}
	});
};

const initFields = () => {
	const fields = document.querySelectorAll('.field');

	fields.forEach(item => {
		let input = item.querySelector(`input[type="text"],
			input[type="email"],
			input[type="tel"],
			input[type="url"],
			input[type="password"],
			input[type="file"],
			textarea`);
		let determineHasValue = () => {
			input.value
				? item.classList.add('has-value')
				: item.classList.remove('has-value');
		};

		if (input) {
			determineHasValue();
			input.addEventListener('change', determineHasValue);
			input.addEventListener('blur', determineHasValue);
		}
	});
};

const initAccordion = () => {
	const accordion = document.querySelectorAll('.comp-accordion');

	accordion.forEach(el => {
		let content = el.querySelector('.accordion-content');
		let button = el.querySelector('.accordion-label');

		//conditional to call function to open accordion on load if data attribute is present
		if ('jsAccordionOpen' in el.dataset) {
			openAccordionOnLoad(el, content, button)
		}
		
		el.querySelector('.accordion-label').addEventListener('click', e => {

			// activate current accordion
			slide('toggle', content);

			if (!el.classList.contains('is-active')) {
				el.classList.add('is-active');
				el.setAttribute('aria-expanded', true);
				content.setAttribute('aria-hidden', false);
				content.setAttribute('tabindex', '0');
			} else {
				el.classList.remove('is-active');
				el.setAttribute('aria-expanded', false);
				content.setAttribute('aria-hidden', true);
				content.setAttribute('tabindex', '-1');
			}

            if (!button.classList.contains('is-active')) {
                button.classList.add('is-active');
                button.setAttribute('aria-expanded', true);
            } else {
				button.classList.remove('is-active');
				button.setAttribute('aria-expanded', false);
            }

			const siblings = el.parentElement.querySelectorAll(':scope > .comp-accordion');

			siblings.forEach(el2 => {
				if (el2 !== el) {
					slide('up', el2.querySelector('.accordion-content'));
					el2.classList.remove('is-active');

					const otherButton = el2.querySelector('.accordion-label');
					const otherContent = el2.querySelector('.accordion-content');

					otherButton?.classList.remove('is-active');
					otherButton?.setAttribute('aria-expanded', false);

					otherContent?.setAttribute('aria-hidden', true);
					otherContent?.setAttribute('tabindex', '-1');
				}
			});
		});
	});
};

// global elements and pages

const initPageTransition = () => {
	document.querySelectorAll('a[href]').forEach(item => {
		// if href points to anchor, or points to anchor that exists on page
		if (
			item.href.startsWith('#') ||
			item.href.split('#')[0] == window.location.href.split('#')[0]
		) {
			item.setAttribute('data-page-transition', 'scroll');
		} else if (
			(item.href.includes(siteUrl) || item.href.startsWith('/')) &&
			item.target != '_blank' &&
			!item.href.includes('mailto:')
		) {
			item.setAttribute('data-page-transition', 'internal');
		}
	});

	document
		.querySelectorAll('[data-page-transition="internal"]')
		.forEach(item => {
			item.addEventListener('click', e => {
				let target = e.target.hasAttribute('data-page-transition')
					? e.target
					: e.target.closest('[data-page-transition]');

				if (
					target.dataset.pageTransition == 'internal' &&
					!root.classList.contains('key-is-down')
				) {
					e.preventDefault();
					root.classList.remove(
						'header-is-sticky',
						'menu-is-active',
						'mobile-menu-is-active',
						'minicart-is-active'
					);
					root.classList.add('is_leaving');
					document.querySelector('.header-menu.is-active')
						? document
								.querySelector('.header-menu.is-active')
								.classList.remove('is-active')
						: '';

					setTimeout(function() {
						window.location.href = target.href;
					}, 400);
				} else if (target.dataset.pageTransition == 'scroll') {
					e.preventDefault();
					// TODO: scroll function to be added
				}
			});
		});

	window.addEventListener('keydown', () => {
		root.classList.add('key-is-down');
	});

	window.addEventListener('keyup', () => {
		root.classList.remove('key-is-down');
	});
};

const initPageAnimation = () => {
	document.querySelectorAll('[data-animate]').forEach(item => {
		let observer = new IntersectionObserver(
			el => {
				if (
					el[0].isIntersecting === true &&
					!el[0].target.classList.contains('is-animated')
				) {
					el[0].target.classList.add('is-animated');
				}
			},
			{ threshold: [0.4] }
		); // 0 = page start; 1 = page bottom, items only revealed when in full view

		observer.observe(item);
	});
};

const initProductSlider = () => {
	document.querySelectorAll('.comp-product-slider').forEach(item => {
		let editorialBlock = item.querySelector('.product-slider-editorial');
		if (!editorialBlock) return false;

		let editorialBlockClone = editorialBlock.cloneNode(true);

		if (editorialBlock && window.innerWidth <= 900) {
			let slider = item.querySelector('[data-flickity-slider]');
			if (!slider) return false;
			let productCardThird = slider.querySelector('.product-card:nth-child(3)');
			let productCardFirst = slider.querySelector('.product-card:nth-child(1)');



			item.classList.contains('editorial-is-inline')
				? slider.prepend(editorialBlockClone)
				: productCardThird
				? productCardThird.parentNode.insertBefore(
						editorialBlockClone,
						productCardThird.nextSibling
				  )
				: productCardFirst
				? productCardFirst.parentNode.insertBefore(
						editorialBlockClone,
						productCardFirst.nextSibling
				  )
				: null;

			editorialBlock.remove();
		}
	});
};

const initContentLayout = () => {
	// iframe fit vids
	reframe(
		`.content-layout iframe[src*="vimeo.com"],
		.content-layout iframe[src*="youtube.com"]`,
		'video-reframe'
	);

	// unwrap image from paragraph tag
	let contentLayout = document.querySelector('.content-layout');
	if (contentLayout) {
		[].forEach.call(contentLayout.getElementsByTagName('img'), function(img) {
			let p = img.closest('p');

			if (p && p.parentElement) {
				p.parentElement.insertBefore(img, p);
				p.parentElement.removeChild(p);
			}
		});
	}
};

const initFlickitySlider = (slider, customIndex = 0) => {
	const flickitySlider = slider
		? [slider]
		: document.querySelectorAll('[data-flickity-slider]');

	const flickitySliderTrigger = () => {
		flickitySlider.forEach(el => {

			let options  = JSON.parse(el.dataset.flickitySlider.replace(/'/g, '"').trim());

			options.on = { 'ready': () => {
				el.querySelector('.flickity-slider').setAttribute('role', 'region');
				el.querySelector('.flickity-slider').setAttribute(
					'aria-label',
					'Carousel'
				);
				el.querySelector('.flickity-slider').setAttribute(
					'aria-live',
					'polite'
				);

				el.querySelector('.flickity-prev-next-button.previous')
					? el
						.querySelector('.flickity-prev-next-button.previous')
						.setAttribute('aria-label', 'Previous slide')
					: '';

				el.querySelector('.flickity-prev-next-button.next')
					? el
						.querySelector('.flickity-prev-next-button.next')
						.setAttribute('aria-label', 'Next slide')
					: '';

				el.querySelector('.flickity-page-dots')
					? el
						.querySelectorAll('.flickity-page-dots .dot').forEach(
							(dot, index)=>{
								var newBtn = document.createElement('button');
								newBtn.setAttribute('data-slide-index', index);
								newBtn.setAttribute('aria-label', `Slide ${index + 1}`);

								newBtn.addEventListener('click', ()=>{
									flickity.select (newBtn.dataset.slideIndex, false, false );
								})
								dot.appendChild(newBtn);
							}
						)
					: '';
			}};

			let flickity = new FlickityResponsive(
				el,
				options
			);

			if (slider) {
				flickity.resize();
			}

			let childrenWidth = Object.values(
				el.querySelector('.flickity-slider').childNodes
			).reduce(
				(total, i) => (i.offsetWidth ? total + i.offsetWidth : total),
				0
			);

			const changeFlickitySlideVisibility = function(slides) {
				if (!slides.length) {
					return null;
				}

				slides.forEach(slide => {
					const selectableElements = slide.element.querySelectorAll('a, button');
					if (slide.element.getAttribute('aria-hidden')) {
						Array.from(selectableElements).forEach(el => {
							el.setAttribute('aria-hidden', true);
							el.setAttribute('tabindex', -1);
						});
					} else {
						Array.from(selectableElements).forEach(el => {
							el.setAttribute('aria-hidden', false);
							el.setAttribute('tabindex', 0);
						});
					}
				})
			}

			flickity.on('change', index => {
				changeFlickitySlideVisibility(flickity.cells)
			});

			// Wait for all third part links to appear.
			setTimeout(function() {
				changeFlickitySlideVisibility(flickity.cells)
			}, 1000)

			if (el.classList.contains('hero-images-flickity-slider')) {
				let heroImageFlickitySlider = document.querySelector(
					'.hero-images-flickity-slider'
				);
				let imageTrigger = heroImageFlickitySlider.querySelectorAll(
					'[data-image-trigger].is-shown'
				);
				previousIndex = 0;

				imageTrigger.forEach((el, i) => {
					el.setAttribute('data-image-nav', i + 1);
				});

				// If a specific image is selected, we need to set the index - 1.
				if (customIndex != 0) {
					customIndex = parseInt(customIndex);
				}
				imageTrigger[customIndex].click();
				flickity.select(customIndex, false, false);

				flickity.on('change', index => {
					// get changed index
					let delta = index - previousIndex;
					let lastIndex = el.querySelectorAll('[data-image-nav]').length - 1;
					let imageTriggerActive = heroImageFlickitySlider.querySelector(
						'[data-image-nav].is-active'
					);
					let imageTriggerActiveIndex =
						parseInt(imageTriggerActive.dataset.imageNav) - 1;

					if (
						(delta > 0 || (previousIndex == lastIndex && index === 0)) &&
						!(previousIndex === 0 && index == lastIndex)
					) {
						imageTriggerActiveIndex == lastIndex
							? imageTrigger[0].click()
							: imageTrigger[imageTriggerActiveIndex + 1].click();
					} else {
						imageTriggerActiveIndex == 0
							? imageTrigger[lastIndex].click()
							: imageTrigger[imageTriggerActiveIndex - 1].click();
					}

					changeFlickitySlideVisibility(flickity.cells)

					previousIndex = index;
				});
			}

			if (
				// if total children width is lesser than slider width
				el.getBoundingClientRect().width >= childrenWidth ||
				// if flickity slider has breakpoint set, and window is greater than breakpoint
				(el.dataset.flickityBreakpoint &&
					window.innerWidth > parseInt(el.dataset.flickityBreakpoint))
			) {
				// destroy flickity
				flickity.destroy();

				setTimeout(() => {
					el.querySelectorAll('[style*="left:"]').forEach(item => {
						item.style.setProperty('left', 'unset');
					});
				}, 400);
			} else if (el.classList.contains('is-draggable')) {
				// avoid click on drag: https://github.com/metafizzy/flickity/issues/838
				flickity.on('dragStart', () => {
					flickity.slider.childNodes.forEach(
						slide => (slide.style.pointerEvents = 'none')
					);
				});

				flickity.on('dragEnd', () => {
					flickity.slider.childNodes.forEach(
						slide => (slide.style.pointerEvents = 'all')
					);
				});
			}
		});
	};

	flickitySliderTrigger();
	window.addEventListener('resize', flickitySliderTrigger);

	// swipe fix for IOS
	var touchingCarousel = false;
	var touchStartCoords;

	document.body.addEventListener('touchstart', function(e) {
		if (e.target.closest('.flickity-slider')) {
			touchingCarousel = true;
		} else {
			touchingCarousel = false;
			return;
		}

		touchStartCoords = {
			x: e.touches[0].pageX,
			y: e.touches[0].pageY,
		};
	});

	document.body.addEventListener(
		'touchmove',
		function(e) {
			if (!(touchingCarousel && e.cancelable)) {
				return;
			}

			var moveVector = {
				x: e.touches[0].pageX - touchStartCoords.x,
				y: e.touches[0].pageY - touchStartCoords.y,
			};

			if (Math.abs(moveVector.x) > 7) {
				e.preventDefault();
			}
		},
		{
			passive: false,
		}
	);
};

const initVideoLightbox = () => {
	const videos = document.querySelectorAll('[data-video-lightbox-trigger]');

	videos.forEach(item => {
		let videoId = item.dataset.videoLightboxTrigger;

		// setup HTML then append
		let div = document.createElement('div');
		div.classList.add('comp-video-lightbox');
		div.setAttribute('data-video-lightbox', videoId);

		div.innerHTML = `
			<button
				class="video-lightbox-close cr-white"
				aria-label="close video"
				type="button"><svg class="svg-close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.23 15.32"><path fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-width="1.03" d="M.51,14.71,14.71.51M.52.61l14.19,14.2" /></svg></button>

			<iframe
				class="video-lightbox-iframe"
				src="${
					item.dataset.videoLightboxSource == 'youtube'
						? `https://www.youtube.com/embed/`
						: `https://player.vimeo.com/video/`
				}${videoId}"
				frameborder="0"
				allowfullscreen></iframe>
		`;

		document.body.appendChild(div);

		// open video lightbox
		item.addEventListener('click', e => {
			document
				.querySelector(
					`[data-video-lightbox="${e.target.dataset.videoLightboxTrigger}"]`
				)
				.classList.add('is-active');
		});
	});

	// close video lightbox
	document.querySelectorAll('.video-lightbox-close').forEach(item => {
		item.addEventListener('click', e => {
			let videoLightbox = e.target.closest('.comp-video-lightbox');

			videoLightbox.classList.remove('is-active');

			setTimeout(() => {
				videoLightbox.querySelector('iframe').src = videoLightbox.querySelector(
					'iframe'
				).src;
			}, 400);
		});
	});
};

const initProductSingle = () => {
	const heroSection = document.querySelector('.product-hero');
	const imageThumbnails = heroSection.querySelector('.image-thumbnails');
	const imageTrigger = heroSection.querySelectorAll('[data-image-trigger]');
	const image = heroSection.querySelectorAll('[data-image]');

	heroSection
		.querySelector('.js-image-featured-prev')
		.addEventListener('click', () => {
			imageThumbnails
				.querySelector('.flickity-prev-next-button.previous')
				.click();
		});

	heroSection
		.querySelector('.js-image-featured-next')
		.addEventListener('click', () => {
			imageThumbnails.querySelector('.flickity-prev-next-button.next').click();
		});

	imageTrigger.forEach(item => {
		item.addEventListener('click', e => {
			let target = e.target.hasAttribute('data-image-trigger')
				? e.target
				: e.target.closest('[data-image-trigger]');
			let trigger =
				parseInt(target.dataset.imageTrigger) > image.length
					? Math.round(target.dataset.imageTrigger - image.length).toString()
					: target.dataset.imageTrigger;

			imageTrigger.forEach(el => {
				el == target
					? el.classList.add('is-active')
					: el.classList.remove('is-active');
			});

			image.forEach(el => {
				el.dataset.image == trigger
					? el.classList.add('is-active')
					: el.classList.remove('is-active');
			});
		});
	});

	for (let i = 0; i < imageTrigger.length; i++) {
		if (imageTrigger[i].classList.contains('is-shown')) {
			imageTrigger[i].click();
			break;
		}
	}
	const variantIdSelector = heroSection.querySelector('select[name="id"]');
	const variantSelectedPrice = document.querySelectorAll(
		'.variant-selected-price'
	);
	const variantSelectedTitle = document.querySelectorAll(
		'.variant-selected-title'
	);

	if (variantIdSelector) {
		variantIdSelector.addEventListener('change', () => {
			let optionSelected =
				variantIdSelector.options[variantIdSelector.selectedIndex];
			let optionValue = optionSelected?.value;

			// update all pricing
			variantSelectedPrice.forEach(item => {
				item.innerHTML = optionSelected.dataset.variantPrice;
			});

			// update variant title
			variantSelectedTitle.forEach(item => {
				item.innerHTML = optionSelected.text;
			});

			// update buy now URL
			let buynowButton = heroSection.querySelector('.content-buynow');
			if (buynowButton) {
				buynowButton.href = optionSelected.dataset.variantBuynowUrl;
			}

			// re-initialize image slider
			let heroImagesSlider = heroSection.querySelectorAll(
				'[data-flickity-slider]'
			);
			let selectorValues = [];

			if (window.innerWidth <= 900) {
  
			} else {
				for (let i = 0; i < variantIdSelector.options.length; i++) {
					if (variantIdSelector.options[i].value) {
						selectorValues.push(
							formatHandleize(variantIdSelector.options[i].text)
						);
					}
				}

				heroImagesSlider.forEach(item => {
					let customIndex = '';
					item.querySelectorAll('[data-image-alt]').forEach(el => {
						el.classList.add('is-shown');

						if (
							selectorValues.includes(el.dataset.imageAlt) &&
							el.dataset.imageAlt != formatHandleize(optionSelected.text)
						) {
							el.classList.remove('is-shown');
						}

						if (el.classList.contains('is-shown')) {
							if (el.dataset.variantId == optionValue) {
								if (!el.classList.contains('is-active')) {
									el.classList.add('is-active');
								}
								if (!el.classList.contains('is-selected')) {
									el.classList.add('is-selected');
								}
								if (el.dataset.imageTrigger != undefined) {
									customIndex =  parseInt(el.dataset.imageTrigger) - 1;
								}
							} else {
								el.classList.remove('is-active');
								el.classList.remove('is-selected');
							}
						}
					});

					setTimeout(() => {
						initFlickitySlider(item, customIndex);
					}, 100);
				});
			}
			const variantChange = new CustomEvent("variantChange", {
				detail: {},
				bubbles: true,
				cancelable: true,
				composed: false,
			});
			document.dispatchEvent(variantChange);
		});
	}

	const stickyBar = document.querySelector('.product-sticky-bar');
	const announcementBar = document.querySelector('.global-announcement-banner')
	
	const root = document.documentElement;
	let announcementBarHeight = announcementBar ? '32px' : 0
	root.style.setProperty('--announcement-height', `${announcementBarHeight}` );
	const stickyBarScroll = () => {
		window.scrollY > window.innerHeight
			? stickyBar.classList.add('is-active')
			: stickyBar.classList.remove('is-active');
	};

	stickyBarScroll();
	window.addEventListener('scroll', stickyBarScroll);

	stickyBar
		.querySelector('.sticky-bar-add-trigger')
		.addEventListener('click', e => {
			e.preventDefault();
			const productFrom = heroSection.querySelector('form[action="/cart/add"]');
			const multiProductForm = heroSection.querySelector('form.multiple-items[action="/cart/add"]');
			if (multiProductForm) {
				const multiValues = multiProductForm.querySelector('[name="id"]').value.split(',');
				const items = multiValues.map(function(id) {
					var obj = {};
					obj["id"] = Number(id);
					obj["quantity"] = Number(multiProductForm.querySelector('[name="quantity"]').value);
					return obj
				});
				addItems(items);
			} else if (productFrom) {
				addItem(
					productFrom.querySelector('[name="id"]').value,
					productFrom.querySelector('[name="quantity"]').value
				);
			}
		});
};

   let toolbar = document.querySelector('.collection-toolbar');
   let toolbarCurrent = toolbar?.querySelector('.collection-toolbar-current');
   let toolbarSort = toolbar?.querySelector('.toolbar-sort');
const toolbarRefresh = () => {
	if (!toolbar) return;

	let urlParams = new URLSearchParams(window.location.search);
	let urlParamsSort = urlParams.get('sort_by');

	// determine active state for sort
	if (urlParamsSort && urlParamsSort != 'manual') {
		toolbar.querySelectorAll('[data-sort-trigger]').forEach(item => {
			item.classList.remove('is-active');
		});

		const activeSort = toolbar.querySelector(`[data-sort-trigger="${urlParamsSort}"]`);
		if (activeSort) {
			activeSort.closest('li').classList.add('is-active');
		}
	}

	// determine active filters
	let filterActiveTerms = [];

	toolbar.querySelectorAll(`li.is-active [data-filter-trigger]`).forEach(item => {
		filterActiveTerms.push(item.dataset.filterTrigger);
	});

	if (filterActiveTerms.length) {
		toolbarCurrent.innerHTML = `
			<ul>${filterActiveTerms.map(item => `
				<li><button data-filter-clear-trigger="${item}">${item.split(':')[1]}</button></li>
			`).join('')}</ul>
			<button class="btn-underline" data-filter-clear-trigger="all">Clear</button>
		`;
		toolbarCurrent.classList.add('is-active');
	} else {
		toolbarCurrent.innerHTML = '';
		toolbarCurrent.classList.remove('is-active');
	}
};

const initProductIndex = () => {
	const path = window.location.pathname;

	const isHairTypePage = path.includes('hair-type-straight') || 
						   path.includes('hair-type-curly') || 
						   path.includes('hair-type-wavy') || 
						   path.includes('hair-type-coily');

	const url = new URL(window.location.href);
	const hasSortParam = url.searchParams.has('sort_by');

	const cameFromOutside = document.referrer && !document.referrer.includes(path);

	if (isHairTypePage && !hasSortParam && cameFromOutside) {
		url.searchParams.set('sort_by', 'best-selling');
		window.location.replace(url.toString());
		return;
	}

	const collectionProducts = document.querySelector('.collection-product');
	const loadStat = document.querySelector('.load-stat');



	const productsInfiniteScroll = () => {
		if (document.querySelector('.collection-load')) {
			let loadTrigger = document.querySelector('.load-trigger');
			let loadStatBar = document.querySelector('.load-stat-bar');
			let loadViewedNode = document.querySelector('.load-viewed-count');
			let loadProductsNode = document.querySelector('.load-products-count');
			let infiniteScroll = new InfiniteScroll('.product-load', {
				path: '.load-next-url',
				append: '.product-card',
				button: '.load-trigger',
				scrollThreshold: false,
				history: false,
			});

		 	let lastPID;

			infiniteScroll.on('request', () => {
				initLoadingBar('start');
				// save PID of last item
				lastPID = collectionProducts?.firstElementChild?.lastElementChild?.dataset?.productId;
			});

			infiniteScroll.on('load', () => {
				initLoadingBar('done');
				loadTrigger.style.display = 'inline-block';

				let collectionProductCount = parseInt(
					loadStatBar.dataset.productsCount
				);

				if (infiniteScroll.pageIndex * 24 > collectionProductCount) {
					document.querySelector(
						'.load-viewed-count'
					).innerHTML = collectionProductCount;
					loadStatBar.style.width = '100.5%';
					loadStatBar.ariaValueNow = collectionProductCount;
					loadTrigger.style.display = 'none';
				} else {
					loadViewedNode.innerHTML =
						infiniteScroll.pageIndex * 24;
					loadStatBar.style.width = `${Math.round(
						((infiniteScroll.pageIndex * 24) / collectionProductCount) * 100
					)}%`;
					loadStatBar.ariaValueNow = infiniteScroll.pageIndex * 24;
				}

				// make sure viewed count is not greater than product count
				const loadViewedCount = parseInt(loadViewedNode.innerHTML);
				const loadProductsCount = parseInt(loadProductsNode.innerHTML);
				if (loadViewedCount >= loadProductsCount) {
					loadViewedNode.innerHTML = loadProductsCount;
				}
			});

			infiniteScroll.on('append', () => {
				initLoadingBar('done');
				// find last item, if exists, and focus next sibling
				// focus first new item (for ADA)
				if (lastPID) {
					const lastProductElement = document.querySelector(`[data-product-id='${lastPID}'`);
					const firstNewElement = lastProductElement?.nextElementSibling;
					const firstFocusable = firstNewElement.querySelector('a');
					const enableTabbing = collectionProducts.classList.contains('enable-tabbing');
					if (firstFocusable && enableTabbing) {
						firstFocusable.classList.add('focus-visible');
						firstFocusable.setAttribute('data-focus-visible-added', '');
						firstFocusable.style.outline = "2px dotted var(--cr-blue)";
						firstFocusable.focus()
						collectionProducts.classList.remove('enable-tabbing');
						firstFocusable.addEventListener('blur', (e) => {
							e.currentTarget.classList.remove('focus-visible');
							e.currentTarget.removeAttribute('data-focus-visible-added');
							e.currentTarget.style.outline = "none";
						})
					}
				}
			});

			infiniteScroll.on('last', function(body, path) {
				initLoadingBar('done');
				loadTrigger.disabled = true;
				loadTrigger.innerHTML = 'You’ve reached the end';
			});

			loadTrigger.addEventListener('keydown', (event) => {
				if (event.key === 'Enter') {
					collectionProducts.classList.add('enable-tabbing');
				}
			});
		}
	};

	// initiate infinite scrolling on load
	productsInfiniteScroll();

	const setDropdownChildBtnTabIndex = (parent, tabindex) => {
		parent.querySelectorAll('li').forEach(li => {
			const button = li.querySelector('button');
			if (button) {
				button.setAttribute('tabindex', tabindex);
			}
		})
	}

	// toggle filter/sort dropdowns for ADA
	document.querySelector('.t-link')?.addEventListener('click', e => {
		let tLink = e.target.closest('.t-link');
		let tDropdown = tLink.closest('.toolbar-dropdown').querySelector('.t-dropdown');
		if (tLink.getAttribute('aria-expanded') == 'false') {
			tLink.setAttribute('aria-expanded', 'true');
			tDropdown.removeAttribute('inert');
			tDropdown.setAttribute('tabindex', '0');
			setDropdownChildBtnTabIndex(tDropdown, '0');
		} else {
			tLink.setAttribute('aria-expanded', 'false');
			tDropdown.setAttribute('inert', 'true');
			tDropdown.setAttribute('tabindex', '-1');
			setDropdownChildBtnTabIndex(tDropdown, '-1');
		}
		document.querySelector('.s-link').setAttribute('aria-expanded', 'false');
		document.querySelector('.s-dropdown').setAttribute('inert', 'true');
		document.querySelector('.s-dropdown').setAttribute('tabindex', '-1');
		setDropdownChildBtnTabIndex(document.querySelector('.s-dropdown'), '-1');
	});

	document.querySelector('.s-link').addEventListener('click', e => {
		let sLink = e.target.closest('.s-link');
		let sDropdown = sLink.closest('.toolbar-dropdown').querySelector('.s-dropdown');
		if (sLink.getAttribute('aria-expanded') == 'false') {
			sLink.setAttribute('aria-expanded', 'true');
			sDropdown.removeAttribute('inert');
			sDropdown.setAttribute('tabindex', '0');
			setDropdownChildBtnTabIndex(sDropdown, '0');
		} else {
			sLink.setAttribute('aria-expanded', 'false');
			sDropdown.setAttribute('inert', 'true');
			sDropdown.setAttribute('tabindex', '-1');
			setDropdownChildBtnTabIndex(sDropdown, '-1');
		}
		document.querySelector('.t-link').setAttribute('aria-expanded', 'false');
		document.querySelector('.t-dropdown').setAttribute('inert', 'true');
		document.querySelector('.t-dropdown').setAttribute('tabindex', '-1');
		setDropdownChildBtnTabIndex(document.querySelector('.t-dropdown'), '-1');
	});

	// toolbar and product filtering/sorting
	 toolbar = !screenIsMobile
		? document.querySelector('.collection-toolbar')
		: document.querySelector('.collection-toolbar');

	if (!toolbar) return false;

	toolbarCurrent = toolbar.querySelector('.collection-toolbar-current');
	toolbarSort = toolbar.querySelector('.toolbar-sort');

	

	const productRefresh = () => {
		// initiate loading bar
		initLoadingBar('start');

		// fade out product grid
		collectionProducts.classList.add('is-fade-out');

		// generate filter URL
		let filterActiveTerms = [];
		let sortActiveTerm = toolbarSort.querySelector('li.is-active')
			? toolbarSort
					.querySelector('li.is-active')
					.querySelector('[data-sort-trigger]').dataset.sortTrigger
			: false;

		toolbar.querySelectorAll('li.is-active').forEach(item => {
			let tag = item.querySelector('[data-filter-trigger]')
				? item
						.querySelector('[data-filter-trigger]')
						.dataset.filterTrigger.replace(/\s+/g, '-')
						.toLowerCase()
				: '';

			filterActiveTerms.push(tag);
		});
        
		let filterUrl = `${collectionUrl}/${
			filterActiveTerms.length ? filterActiveTerms.join('+') : ''
		}${
			sortActiveTerm && sortActiveTerm != 'manual'
				? `?sort_by=${sortActiveTerm}`
				: ''
		}`;

		// trigger ajax request for products
		fetch(filterUrl)
			.then(function(response) {
				initLoadingBar('move');
				// The API call was successful!
				return response.text();
			})
			.then(data => {
				// convert the HTML string into a document object
				let parser = new DOMParser();
				let dataDoc = parser.parseFromString(data, 'text/html');

				// update URL
				history.pushState({}, '', filterUrl);

				// refresh toolbar
				toolbarRefresh();

				// replace products
				let dataCollectionProduct = dataDoc.querySelector(
					'.collection-product'
				);

				if (dataCollectionProduct) {
					collectionProducts.innerHTML = dataCollectionProduct.innerHTML;
				} else {
					collectionProducts.innerHTML = `<section class="collection-empty">
					<div class="c-2 type-spacing">
						<p>There are no items matching your filters – reset the filters or try a different category to continue.</p>
						<button
							class="btn"
							data-filter-clear-trigger="all">
							Reset Filters</button>
					</div>
				</section>`;
				}

				// replace load stat
				let dataLoadStat = dataDoc.querySelector('.load-stat');
				if (dataLoadStat) {
					loadStat.innerHTML = dataLoadStat.innerHTML;
				}

				// fade in product grid
				setTimeout(function() {
					collectionProducts.classList.remove('is-fade-out');
				}, 10);

				// determine if load more is needed
				if ($(data).find('.collection-load').length) {
					// if load more button already exists
					if (document.querySelector('.collection-load')) {
						// show load more button
						document
							.querySelector('.collection-load')
							.classList.remove('is-fade-out');

						// and update load url
						// $('#infinite-next a');
						let nextUrl = dataDoc.querySelector('a.load-next-url').getAttribute('href');
						document
							.querySelector('.load-next-url')
							.setAttribute('href', nextUrl);
					} else {
						// else, grab from new page
						collectionProducts.after(`
						${$(data)
							.find('#collection-load-more')
							.prop('outerHTML')}
						${$(data)
							.find('#infinite-next')
							.prop('outerHTML')}
					`);
					}

					productsInfiniteScroll();
				} else {
					document
						.querySelector('.collection-load')
						.classList.add('is-fade-out');
				}

				// end loading bar
				initLoadingBar('done');
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	// toggle filter/sort dropdowns
	const toolbarDropdown = toolbar.querySelectorAll('.toolbar-dropdown');
	const toolbarDropdownClose = () => {
		toolbarDropdown.forEach(item => {
			item.classList.contains('is-active')
				? item.classList.remove('is-active')
				: '';
		});
	};

	toolbarDropdown.forEach(item => {
		item
			.querySelector('[data-dropdown-trigger]')
			.addEventListener('click', e => {
				let target = e.target.hasAttribute('data-dropdown-trigger')
					? e.target
					: e.target.closest('[data-dropdown-trigger]');

				setTimeout(toolbarDropdownClose, 5);

				if (
					!target.closest('.toolbar-dropdown').classList.contains('is-active')
				) {
					setTimeout(() => {
						target.closest('.toolbar-dropdown').classList.add('is-active');
					}, 10);
				}
			});
	});

	window.addEventListener('click', e => {		
		if (e.target != null && e.target.classList.contains('t-link')) {
			return;
		}

		if (e.target != null && e.target.classList.contains('s-link')) {
			return;
		}

		if (
			!e.target.classList.contains('toolbar-dropdown') &&
			!e.target.closest('.toolbar-dropdown')
		) {
			toolbarDropdownClose();
		}

		if (
			e.target.hasAttribute('data-filter-trigger') ||
			e.target.closest('[data-filter-trigger]')
		) {

			let target = e.target.hasAttribute('data-filter-trigger')
				? e.target.closest('[data-filter-trigger]')
				: e.target;
			let dropdown = target.closest('.toolbar-dropdown');

			dropdown.querySelectorAll('li').forEach(el => {
				el.classList.remove('is-active');
			});

			const filterTrigger = target.closest('[data-filter-trigger]');
			const term = filterTrigger?.dataset.filterTrigger.replace(/\s+/g, '-').toLowerCase();
			const sort = document.querySelector('.s-dropdown .is-active');
            console.log('collectionUrl' , collectionUrl, term)
			let filterURL = `${collectionUrl}`;
			if (term) {
				filterURL += `/${term}`;
			}
			if (sort) {
				const sortTrigger = sort.querySelector('[data-sort-trigger]');
				if (sortTrigger) {
					filterURL += `?sort_by=${sortTrigger.dataset.sortTrigger}`;
				}
			}
			window.location.href = filterURL;
		}
        
if (
	e.target.hasAttribute('data-sort-trigger') ||
	e.target.closest('[data-sort-trigger]')
) {
	let target = e.target.closest('[data-sort-trigger]');
	let sortValue = target?.dataset?.sortTrigger;

	console.log('Target sort value:', sortValue);

	// Asegura que el li tenga clase activa visualmente
	let dropdown = target.closest('.toolbar-dropdown');
	dropdown.querySelectorAll('li').forEach(el => el.classList.remove('is-active'));
	target.closest('li').classList.add('is-active');

	// Conserva el path actual (ej: /collections/all/hair-type-straight)
	let currentPath = window.location.pathname;

	// Conserva todos los parámetros de la URL actual
	let urlParams = new URLSearchParams(window.location.search);
  console.log('urlParams ',urlParams )
	if (sortValue && sortValue !== 'manual') {
		urlParams.set('sort_by', sortValue);
	} else {
		urlParams.delete('sort_by');
	}
  console.log('urlParams2 ',urlParams )
	let newUrl = `${currentPath}${urlParams.toString() ? '?' + urlParams.toString() : ''}`;
	console.log('New URL:', newUrl);

	// Redirige
	window.location.href = newUrl;
}

		if (
			e.target.hasAttribute('data-filter-clear-trigger') ||
			e.target.closest('[data-filter-clear-trigger]')
		) {
			let target = e.target.hasAttribute('data-filter-clear-trigger')
				? e.target.closest('[data-filter-clear-trigger]')
				: e.target;
			let term = target.dataset.filterClearTrigger;

			window.location.href = collectionUrl;
		}
	});

	// reset toolbar on load
	toolbarRefresh();
};

const initSearchIndex = () => {
	const resultsTabTrigger = document.querySelectorAll(
		'[data-results-tab-trigger]'
	);
	const resultsTab = document.querySelectorAll('[data-results-tab]');

	resultsTabTrigger.forEach(item => {
		item.addEventListener('click', () => {
			resultsTabTrigger.forEach(el => {
				el.dataset.resultsTabTrigger == item.dataset.resultsTabTrigger
					? el.classList.add('is-active')
					: el.classList.remove('is-active');
			});

			resultsTab.forEach(el => {
				el.dataset.resultsTab == item.dataset.resultsTabTrigger
					? el.classList.add('is-active')
					: el.classList.remove('is-active');
			});
		});
	});
};

const initCart = () => {
	let minicart = document.querySelector('.global-minicart');
	let cartIsMinicart = true;
	if (!minicart) {
		minicart = document.getElementById('shopify-section-cart-content');
		cartIsMinicart = false;
	}

	// Set boolean to enforce max limit
	const maxOverrideLimit = minicart.dataset.maxOverride || 0
	const maxLimitSet = (maxOverrideLimit > 0) ? true : false;

	// cart visibility
	const minicartClose = () => {
		root.classList.remove('minicart-is-active');
		history.pushState(null, null, ' ');
		minicart.setAttribute('aria-hidden', true);
		minicart.setAttribute('tabindex', '-1');
	};

	const minicartOpen = () => {
		if (document.querySelector('.global-minicart')) {
			root.classList.add('minicart-is-active');
			history.pushState(null, null, '#cart');
			minicart.setAttribute('aria-hidden', false);
			minicart.setAttribute('tabindex', '0');
			minicart.focus();
		}
	};

	document.addEventListener('click', e => {
		// open cart trigger
		if (
			e.target &&
			(e.target.classList.contains('minicart-open') ||
				e.target.closest('.minicart-open'))
		) {
			root.classList.contains('minicart-is-active')
				? minicartClose()
				: minicartOpen();
		}

		// close cart trigger
		if (
			e.target &&
			(e.target.classList.contains('minicart-close') ||
				e.target.closest('.minicart-close'))
		) {

			if (lastFocusedElement != null) {
				lastFocusedElement.focus()
			} else {
				document.querySelector('.minicart-open').focus();
			}
			minicartClose();
		}
	});

	// Trap focus in minicart only
	if (cartIsMinicart) {
		let focusableEls = minicart.querySelectorAll(
			'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
		);
		let firstFocusableEl = focusableEls[0];
		let lastFocusableEl = focusableEls[focusableEls.length - 2];
		let KEYCODE_TAB = 9;

		minicart.addEventListener('keydown', function(e) {
			let isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

			if (!isTabPressed) {
				return;
			}

			if (e.shiftKey) {
				/* shift + tab */ if (document.activeElement === firstFocusableEl) {
					lastFocusableEl.focus();
					e.preventDefault();
				}
			} /* tab */ else {
				if (document.activeElement === lastFocusableEl) {
					firstFocusableEl.focus();
					e.preventDefault();
				}
			}
		});
	}

	// trigger cart if url contains the hash
	if (location.hash == '#cart') {
		minicartOpen();
	}

	this.checkCartQuantities = () => {
		if (!maxLimitSet) {
			return null;
		}
		fetch('/cart.js')
			.then(function(response) {
				return response.json();
			})
			.then(data => {
				const cartItems = data.items || []
				if (cartItems.length <= 0) {
					return null;
				}

				const productsToAdjust = [];
				cartItems.forEach( item => {
					if (item.quantity > maxOverrideLimit) {
						productsToAdjust.push(
							{
								id: item.variant_id,
								qty: maxOverrideLimit
							}
						);
					}
				})

				if (productsToAdjust.length) {
					productsToAdjust.forEach( product => {
						this.changeItemQuantity(
							String(product.id),
							String(product.qty),
							true,
							false,
							false,
							reloadCartItems
						);
					})
				}
			})
			.catch(error => {
				console.error('Error:', error);
			});
	}

	// updates both cart price and item count
    const originalPromoMessage = document.querySelector('.minicart-promo-message') != null ? document.querySelector('.minicart-promo-message').dataset.originalMessage : null
	this.reloadCartData = () => {
		fetch('/cart.js')
			.then(function(response) {
				return response.json();
			})
			.then(data => {
				if (originalPromoMessage != null) {
					const miniCartPromo =  document.querySelector('.minicart-promo-message')
					const promoTresholdValue = parseInt(miniCartPromo.dataset.promoTreshold)

					if ((data.total_price / 100).toFixed(2) >= promoTresholdValue) {
					miniCartPromo.classList.add('promo-available')
					miniCartPromo.querySelector('strong').innerText = 'You qualify for FREE SHIPPING!'
					} else {
					miniCartPromo.classList.remove('promo-available')
					miniCartPromo.querySelector('strong').innerText = originalPromoMessage
					}
				}
				document.querySelectorAll('.cart-total-price').forEach(item => {
					item.innerText = `$${parseFloat(data.total_price / 100).toFixed(2)}`;
				});

				document.querySelectorAll('.cart-total-items').forEach(item => {
					item.innerText = data.item_count;
				});
				document.querySelectorAll('.minicart-open').forEach(item => { item.setAttribute('aria-label', `Cart with ${data.item_count} item${data.item_count === 1 ? `` : `s`}`)});

				data.item_count > 0
					? root.classList.add('cart-has-items')
					: root.classList.remove('cart-has-items');
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	// updates .cart-items HTML
	this.reloadCartItems = () => {
		reloadCartData();

		fetch('/cart')
			.then(response => {
				return response.text();
			})
			.then(data => {
				var parser = new DOMParser();
				var dataHtml = parser.parseFromString(data, 'text/html');

				// Set cart variables needed to determine cart or minicart.
				let cartItemsClass = '';
				let cartItemsHTML = '';
				let cartItemsWrapper = '';
				let upSellWrapper = '';

				// Check to see if minicart is open or not to determine inserting items there.
				let isMiniCart = document.querySelector('.global-minicart');
				if (isMiniCart) {
					cartItemsClass = '.cart-content-items';
					cartItemsWrapper = '.cart-items-wrapper';

					// Since minicart HTML is different from cart, we need to parse out upsell.
					upSellWrapper = dataHtml.querySelector('.cart-items-upsell');
				} else {
					cartItemsClass = '.cart-content-items';
					cartItemsWrapper = '.cart-content-items';
				}

				// Pull cart items out of dataHtml (which is from /cart)
				let cartItems = dataHtml.querySelectorAll(cartItemsClass);
				cartItems.forEach( item => {
					cartItemsHTML += item.outerHTML;
				});

				// Insert the HTML back into the DOM.
				document.querySelectorAll(cartItemsWrapper).forEach(item => {
					item.innerHTML = cartItemsHTML;
				});
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	// use this function to add items
	this.addItem = (
		variantId,
		quantity,
		updateCartTotal = true,
		updateCartItems = true,
		minicartOpenDelay = 1200,
		callback
	) => {
		initLoadingBar('start');

		console.log('variantID', variantId, quantity)

		fetch('/cart/add.js', {
			method: 'POST',
			body: JSON.stringify({
				id: variantId,
				quantity: quantity,
			}),
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest',
			},
			credentials: 'same-origin',
		})
			.then(response => {
				response.json();
			})
			.then(data => {

				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay
					? setTimeout(() => {
							minicartOpen();
					  }, minicartOpenDelay)
					: '';
				callback ? callback() : '';

				if (maxLimitSet) {
					this.checkCartQuantities();
				}
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	this.addItems = (
		items,
		itemClicked = null,
		updateCartTotal = true,
		updateCartItems = true,
		minicartOpenDelay = 1200,
		callback
	) => {
		initLoadingBar('start');

		fetch('/cart/add.js', {
			method: 'POST',
			body: JSON.stringify({ items }),
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest',
			},
			credentials: 'same-origin',
		})
			.then(response => {
				response.json();
			})
			.then(data => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay
					? setTimeout(() => {
							minicartOpen();
					  }, minicartOpenDelay)
					: '';
				callback ? callback() : '';

				if (maxLimitSet) {
					this.checkCartQuantities();
				}

				if (itemClicked != null) {
					lastFocusedElement = itemClicked;
				}

			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	// use this function to change item quantity
	this.changeItemQuantity = (
		variantId,
		quantity,
		updateCartTotal = true,
		updateCartItems = false,
		minicartOpenDelay = 400,
		callback
	) => {
		fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({
				id: variantId,
				quantity: quantity
			}),
		})
			.then(response => {
				response.json();
			})
			.then(() => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay
					? setTimeout(() => {
							minicartOpen();
					  }, minicartOpenDelay)
					: '';
				callback ? callback() : '';
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	document.addEventListener('click', e => {
		// change quantity trigger
		if (
			e.target &&
			(e.target.dataset.quantityTrigger ||
				e.target.closest('[data-quantity-trigger]'))
		) {
			let target = e.target.dataset.quantityTrigger
				? e.target
				: e.target.closest('[data-quantity-trigger]');
			let item = target.closest('.cart-item');

			if (item) {
				let quantityInput = target
					.closest('.item-quantity')
					.querySelector('[name="quantity"]');
				let updateAllQuantityInput = () => {
					item.querySelectorAll('[name="quantity"]').forEach(item => {
						if (item != quantityInput) {
							item.value = quantityInput.value;
						}
					});
				};

				if (item.querySelectorAll('[data-quick-add-id]')) {
					item.querySelectorAll('[data-quick-add-id]').forEach(el => {
						el.setAttribute('data-quick-add-quantity', quantityInput.value);
					});
				}

				setTimeout(() => {
					item.querySelectorAll('.item-line-price').forEach(el => {
						el.innerHTML = `$${(
							parseInt(
								item
									.querySelector('.item-price')
									.innerHTML.replace(/[^0-9]/g, '') / 100
							) * parseInt(quantityInput.value)
						).toFixed(2)}`;
					});

					if (!item.classList.contains('has-quick-add')) {
						changeItemQuantity(
							item.dataset.itemId,
							quantityInput.value,
							true,
							false,
							false,
							updateAllQuantityInput
						);
					}
				}, 10);
			}
		}

		// remove item trigger
		if (
			e.target &&
			(e.target.classList.contains('item-remove-trigger') ||
				e.target.closest('.item-remove-trigger'))
		) {
			let target = e.target.classList.contains('item-remove-trigger')
				? e.target
				: e.target.closest('.item-remove-trigger');
			let item = target.closest('.cart-item');

			item.remove();
			changeItemQuantity(item.dataset.itemId, 0, true, false, false);
		}

		// add item trigger
		if (
			e.target &&
			(e.target.dataset.cartAdd || e.target.closest('[data-set-cart-add]'))
		) {
			let target = e.target.dataset.cartAdd
				? e.target
				: e.target.closest('[data-set-cart-add]');

			addItem(
				target.dataset.cartAdd,
				target.dataset.cartAddQuantity ? target.dataset.cartAddQuantity : 1
			);
		}
	});

	this.handleVariantSelectorChange = function (args) {
		const item = args.item;
		const select = args.select;
		const selectedOption = args.selectedOption;

		if (!item || !select || !selectedOption) {
			return null;
		}

		item.querySelectorAll('.item-price, .item-info-price').forEach(el => {
			el.innerHTML = selectedOption.dataset.variantPrice;
		});

		item.querySelectorAll('.item-line-price').forEach(el => {
			el.innerHTML = `$${(
				parseInt(
					selectedOption.dataset.variantPrice.replace(/[^0-9]/g, '') / 100
				) * parseInt(item.querySelector('[name="quantity"]').value)
			).toFixed(2)}`;
		});

		const delayedAddItem = () => {
			setTimeout(() => {
				addItem(
					select.value,
					parseInt(item.querySelector('[name="quantity"]').value),
					true,
					true,
					false
				);
			}, 500);
		};

		if (!item.classList.contains('has-quick-add')) {
			changeItemQuantity(
				item.dataset.itemId,
				0,
				false,
				false,
				false,
				delayedAddItem
			);
		}

		if (item.classList.contains('has-quick-add')) {
			if (item.querySelectorAll('[data-quick-add-id]')) {
				item.querySelectorAll('[data-quick-add-id]').forEach(el => {
					el.setAttribute('data-quick-add-id', select.value);
				});
			}
		}

		item.setAttribute('data-item-id', select.value);
	};

	// switch variant on product pages/none cart items
	document.addEventListener('change', (e, el) => {
		//let select = e.path[0];
		let select = e.target;
		if (select.options) {
			let selectedOption = select.options[select.selectedIndex];

			let item = select.closest('.cart-item');

			this.handleVariantSelectorChange({
				item,
				select,
				selectedOption
			});
		}
	});

	// switch variant in cart items
	document.querySelectorAll('.cart-item').forEach(item => {
		let variantSelector = item.querySelector('select[name="id"]');

		if (variantSelector) {
			variantSelector.addEventListener('change', (e, el) => {
				//let select = e.path[0];
				let select = e.target;
				let selectedOption = select.options[select.selectedIndex];

				this.handleVariantSelectorChange({
					item,
					select,
					selectedOption
				})
			});
		}
	});

	// Add Multiple Item product form submissions
	document.querySelectorAll('form.multiple-items[action="/cart/add"]').forEach(form => {
		form.addEventListener('submit', e => {
			e.preventDefault();
			multiValues=form.querySelector('[name="id"]').value.split(',');
			const items = multiValues.map(function(id) {
				var obj = {};
				obj["id"] = Number(id);
				obj["quantity"] = Number(form.querySelector('[name="quantity"]').value);
				return obj
				});

			addItems(items);
		});
	});

	// product form submissions
	document.querySelectorAll('form:not(.multiple-items)[action="/cart/add"]').forEach(form => {
		form.addEventListener('submit', e => {
			e.preventDefault();
			addItem(
				form.querySelector('[name="id"]').value,
				form.querySelector('[name="quantity"]').value
			);
		});
	});

	// quick-add select menus
	document.addEventListener('change', e => {
		if (e.target &&
				e.target.dataset.quickAdd
		) {
			let target = e.target;

			let delayedLoadingBarDone = () => {
				setTimeout(() => {
					initLoadingBar('done');
				}, 1200);
			};

			initLoadingBar('start');

			addItem(
				target.value,
				1,
				true,
				true,
				1200,
				delayedLoadingBarDone
			);
		}
	});

	// quick-add
	document.addEventListener('click', e => {
		if (
			e.target &&
			(e.target.dataset.quickAddId || e.target.closest('[data-quick-add-id]'))
		) {
			let target = e.target.dataset.quickAddId
				? e.target
				: e.target.closest('[data-quantity-trigger]');

			let delayedLoadingBarDone = () => {
				setTimeout(() => {
					initLoadingBar('done');
				}, 1200);
			};

			initLoadingBar('start');

			addItem(
				target.dataset.quickAddId,
				target.dataset.quickAddQuantity ? target.dataset.quickAddQuantity : 1,
				true,
				true,
				1200,
				delayedLoadingBarDone
			);
		}
	});

	document.addEventListener('click', e => {
		const trigger =
			e.target?.dataset?.quickAddFirstId
			? e.target
			: e.target.closest('[data-quick-add-first-id]');

		if (!trigger) return;

		const firstId = trigger.dataset.quickAddFirstId;
		const secondId = trigger.dataset.quickAddSecondId;
		const quantity = parseInt(trigger.dataset.quickAddQuantity || 1, 10);

		const delayedLoadingBarDone = () => {
			setTimeout(() => {
			initLoadingBar('done');
			}, 1200);
		};

		const items = [
			{ id: firstId, quantity }
		];
		if (secondId) {
			items.push({ id: secondId, quantity });
		}

		initLoadingBar('start');

		addItems(
			items,
			true,
			true,
			1200,
			() => {
				setTimeout(() => {
					initLoadingBar('done');
				}, 1200);
			}
		);

	});


	// ecodrive
	let ecoDriveToggleInput = document.querySelector('#ecodrive-toggle-input');

	if (ecoDriveToggleInput) {
		const ecoDriveItem = document.querySelector(
			`[data-item-id="${ecoDriveToggleInput.value}"]`
		);

		if (ecoDriveItem) {
			ecoDriveItem.style.display = 'none';
			changeItemQuantity(ecoDriveToggleInput.value, 1, true, false, false);
			ecoDriveToggleInput.checked = true;
		}

		ecoDriveToggleInput.addEventListener('change', () => {
			ecoDriveToggleInput.checked
				? addItem(ecoDriveToggleInput.value, 1, true, false, false)
				: changeItemQuantity(ecoDriveToggleInput.value, 0, true, false, false);
		});
	}

	if (maxLimitSet) {
		this.checkCartQuantities();
	}
	window.addEventListener("message", (event) => {
		const data = event.data;

		if (data?.eventName === "tolstoyAddToCart") {
			initLoadingBar('start');

			reloadCartData() 
			reloadCartItems()
			setTimeout(() => {
				minicartOpen();
			}, 300)
			callback()
			reloadCartItems()
			setTimeout(() => {
				initLoadingBar('done');
			}, 1200);

					
		}
	});
};

const initBlogIndex = () => {
	if (document.querySelector('blog-pagination-next')) {
		let infiniteScroll = new InfiniteScroll('.blog-load-more', {
			path: '.blog-pagination-next',
			append: '.blog-post',
			button: '.blog-load-more-trigger',
			scrollThreshold: false,
			history: false,
		});

		infiniteScroll.on('last', function(body, path) {
			let loadMoreTrigger = document.querySelector('.blog-load-more-trigger');

			loadMoreTrigger.style.display = 'block';
			loadMoreTrigger.disabled = true;
			loadMoreTrigger.innerHTML = 'You’ve reached the end';
		});
	}
};

const initAccount = () => {
	// account gate
	const gateWrapper = document.querySelector('.account-gate-wrapper');
	const gateContent = document.querySelector('.account-gate');
	const resetPasswordTrigger = document.querySelector(
		'.reset-password-trigger'
	);
	const resetPasswordCancel = document.querySelector('.reset-password-cancel');

	if (gateWrapper) {
		resetPasswordTrigger.addEventListener('click', event => {
			event.preventDefault();

			// update URL with hash
			history.pushState(null, null, '#recover');

			// assign active state
			root.classList.add('reset-password-active');

			// update wrapper height to fit account reset form
			gateWrapper.style.height = document.querySelector(
				'.account-reset'
			).offsetHeight;

			// focus on email field
			document.querySelector('#account-recover-email').focus();
		});

		if (resetPasswordCancel) {
			resetPasswordCancel.addEventListener('click', event => {
				event.preventDefault();

				// remove has from URL
				history.pushState(null, null, ' ');

				// remove active state from root
				root.classList.remove('reset-password-active');

				// update wrapper height to fit account reset form
				gateWrapper.style.height = gateContent.offsetHeight;
			});
		}

		// trigger password recovery form if url contains the hash
		if (location.hash == '#recover') {
			resetPasswordTrigger.click();
		}

		// set initial height
		gateWrapper.style.height = gateContent.offsetHeight;
	}
};

// initiate site
window.addEventListener('DOMContentLoaded', event => {
	// execute pieces and components functions
	initItemQuantity();
	initFields();
	initAccordion();
    toolbarRefresh(); 
	// execute global and component functions
	initPageTransition();
	initPageAnimation();

	initProductSlider();
	initContentLayout();
	initFlickitySlider();
	initVideoLightbox();
	initCart();

   const rellaxWrapper = document.querySelector('.rellax')
    if(rellaxWrapper) {
      	let rellax = new Rellax('.rellax');
    }


	// execute page specific functions
	switch (root.id) {
		case 'product-single':
			initProductSingle();
			break;

		case 'product-index':
			initProductIndex();
			break;

		case 'search-index':
			initSearchIndex();
			break;

		case 'blog-index':
			initBlogIndex();
			break;

		case 'account':
			initAccount();
			break;
	}

	// make visible .avoid-style-flash elements
	setTimeout(function() {
		document.querySelectorAll('.avoid-style-flash').forEach(el => {
			el.style.visibility = 'visible';
		});
	}, 400);

	for (let header of document.querySelectorAll('#scasl-app-container h1')) { let new_header = document.createElement('h2'); new_header.innerHTML = header.innerHTML; header.parentNode.replaceChild(new_header, header); }
});

// Bazaarvoice ADA BV reviews
function fixBazaarvoiceReviewLinks() {
	const productCards = document.querySelectorAll('.product-card')

	productCards.forEach(productCard => {
		const productTitle = productCard.querySelector('.card-info-title')?.textContent?.trim();
		const bvLink = productCard.querySelector('div[data-bv-show="inline_rating"] a')

		console.log('bvLink ', bvLink)
		const count = bvLink.textContent.match(/\d+/)?.[0];

		if (!count || !productTitle) return;

		bvLink.setAttribute(
			'aria-label',
			`Read ${count} reviews for ${productTitle}`
		);
	});
}

// Bazaarvoice loads async
document.addEventListener('DOMContentLoaded', () => {
	setTimeout(fixBazaarvoiceReviewLinks, 2000);
});


document.addEventListener("DOMContentLoaded", () => {
  const marquees = document.querySelectorAll("[data-marquee]");
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  marquees.forEach((marquee) => {
    const id = marquee.dataset.marquee;
    const selector = `.section-marquee-${id}`;
    const toggleBtn = document.querySelector(
      `#shopify-section-${id} .marquee-toggle`
    );

    if (marquee.dataset.initialized === "true") return;
    marquee.dataset.initialized = "true";

	const swiper = new Swiper(selector, {
	slidesPerView: "auto",
	spaceBetween: 24,
	loop: !prefersReducedMotion,
	allowTouchMove: false,
	speed: 3000,
	autoplay: prefersReducedMotion
		? false
		: {
			delay: 0,
			disableOnInteraction: false,
		},
	});

    if (prefersReducedMotion) {
      if (toggleBtn) toggleBtn.style.display = "none";
      return;
    }

    // Pause / Play control (ADA)
    if (toggleBtn) {
      toggleBtn.addEventListener("click", () => {
        const isPaused = toggleBtn.getAttribute("aria-pressed") === "true";

        if (isPaused) {
          swiper.autoplay.start();
        } else {
          swiper.autoplay.stop();
        }

        toggleBtn.setAttribute("aria-pressed", String(!isPaused));
        toggleBtn.textContent = isPaused
          ? "Pause scrolling banner"
          : "Play scrolling banner";
      });
    }
  });
});
